import {
  GET_SPECIALTIES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_SPECIALTIES,
  UPDATE_SPECIALTIES,
  DELETE_SPECIALTIES,
} from "./actionType";

const INIT_STATE = {
  specialties: [],
  error: {},
  success: "",
};

const Specialties = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SPECIALTIES:
          return {
            ...state,
            specialties: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_SPECIALTIES:
          return {
            ...state,
            success: "Successfully created",
            error: {},
          };
        case UPDATE_SPECIALTIES:
          return {
            ...state,
            success: "Successfully updated",
            error: {},
          };
        case DELETE_SPECIALTIES:
          return {
            ...state,
            success: "Successfully Deleted",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SPECIALTIES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_SPECIALTIES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_SPECIALTIES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_SPECIALTIES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_SPECIALTIES: {
      return {
        ...state,
      };
    }
    case CREATE_SPECIALTIES: {
      return {
        ...state,
      };
    }
    case UPDATE_SPECIALTIES:
      return {
        ...state,
      };
    case DELETE_SPECIALTIES:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default Specialties;
